import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { BaseChartDirective, Color, Label } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ReportService } from 'src/app/services/report/report.service';

@Component({
  selector: 'app-merchant-networth',
  templateUrl: './merchant-networth.component.html',
  styleUrls: ['./merchant-networth.component.scss']
})
export class MerchantNetworthComponent implements OnInit {

  @Input() query: any;
  @Input() genReportEvent: EventEmitter<string>;

  reportLoading = false;

  data =
  {
      merchantNetworthReportItems: [],
      totalOrders:0,
      totalChargeCustomer:0,
      totalFulfillCost:0,
      totalNetworth:0,
  };

  constructor(private reportService: ReportService) {
  }

  ngOnInit(): void {
    this.genReportEvent.subscribe(data => {

      this.reportLoading = true;

      var query = JSON.parse(JSON.stringify(this.query));

      query.startDate = moment(query.startDate).format();
      query.endDate = moment(query.endDate).format();

      this.reportService.genMerchantNetworthReport(query).subscribe((data) => {
        this.data = data;

        this.reportLoading = false;
      });
    });
  }

}
